import { render } from "./BodyContent.vue?vue&type=template&id=8ae02e72&ts=true"
import script from "./BodyContent.vue?vue&type=script&lang=ts"
export * from "./BodyContent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__